import React from "react";
import { t } from "@lingui/macro";
import { TooltipHost } from "@fluentui/react";
import { ViewDetailsList, StringToHTML, i18n, cleanHtml } from "idc-ui-react";

const RolesList = ({ roles }) => {
  const columns = [
    {
      key: "name",
      name: i18n._(t`Name`),
      fieldName: "name",
      minWidth: 110,
      maxWidth: 200,
      isResizable: true,
      applyColumnFilter: true,
      applyColumnClick: true,
      isSorted: true,
      isSortedDescending: false
    },
    {
      key: "system",
      name: i18n._(t`IT-System`),
      fieldName: "itSystemName",
      minWidth: 70,
      maxWidth: 110,
      isResizable: true,
      applyColumnFilter: true,
      applyColumnClick: true
    },
    {
      key: "description",
      name: i18n._(t`Description`),
      fieldName: "description",
      minWidth: 110,
      maxWidth: 700,
      isResizable: true,
      applyColumnDisabled: true,
      onRender: ({ description }) => {
        if (description && description.length > 200)
          return (
            <TooltipHost
              tooltipProps={{
                onRenderContent: () => (
                  <StringToHTML text={cleanHtml(description)} />
                )
              }}
            >
              <StringToHTML
                text={description.substring(0, 200) + "..."}
              ></StringToHTML>
            </TooltipHost>
          );
        return <StringToHTML text={cleanHtml(description)}></StringToHTML>;
      }
    }
  ];

  return <ViewDetailsList items={roles} columns={columns} />;
};

export default RolesList;
